<template>
  <div class="ui container">
    <form @submit.prevent="bookNow" class="ui">
      <!-- Seccion de datos fecha reserva -->
      <div class="ui two column stackable grid segment padded" style="">
        <!-- Seccion  fecha reserva y Jugadores -->
        <div class="ui six wide column">
          <div class="column">
            <h4 class="ui dividing header">
              1. Select Players and Holes Number
            </h4>
            <!-- <div class="field" v-show="false">
              <sui-form-fields inline>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    checked="true"
                    name="second_fruit"
                    label="1 Player"
                    value="1"
                  />
                </sui-form-field>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    name="second_fruit"
                    label="2 Players"
                    value="2"
                  />
                </sui-form-field>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    name="second_fruit"
                    label="3 Players"
                    value="3"
                  />
                </sui-form-field>
                <sui-form-field>
                  <sui-checkbox
                    v-model="playersNumber"
                    @onChange="changeHoyos"
                    radio
                    name="second_fruit"
                    label="4 Players"
                    value="4"
                  />
                </sui-form-field>
              </sui-form-fields>
            </div> -->
            <div class="field">
              <div class="four ui buttons">
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '1' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '1';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  1 Player
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '2' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '2';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  2 Players
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '3' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '3';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  3 Players
                </button>
                <button
                  type="button"
                  class="ui button"
                  v-bind:class="[playersNumber == '4' ? 'blue' : 'blue basic']"
                  @click="
                    playersNumber = '4';
                    changePlayersNumber();
                  "
                  style="font-size: 13px"
                >
                  4 Players
                </button>
              </div>
            </div>
            <div class="mt-5">
              <selectTipoJuego
                :GOLF="true"
                v-model="hoyos"
                @onChange="changeHoyos"
              ></selectTipoJuego>
            </div>
            <h4 class="ui dividing header">2. Select Date</h4>
            <div class="field">
              <datepicker
                @selected="selectDate"
                :inline="true"
                :value="input_date.format('MM/DD/YYYY')"
                :disabled-dates="disabledDates"
                :highlighted="highlighted"
              ></datepicker>
            </div>
          </div>
        </div>
        <!-- end Seccion  fecha reserva y Jugadores -->
        <div class="ui ten wide column">
          <div class="column">
            <!-- Seccion  tipo de pago si es hotel -->
            <div class="field">
              <h4 class="ui dividing header">3. Select Rate</h4>
              <v-row>
                <v-col md="6">
                  <v-autocomplete
                    outlined
                    dense
                    v-model="tarifario"
                    :items="tarifaCombo"
                    @input="getTarifasByTarifario()"
                    label="Seleccione un tarifario"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="6">
                  <v-autocomplete
                    :items="listadoTarifas"
                    outlined
                    dense
                    v-model="tarifa"
                    @input="getTarifas()"
                    label="Seleccione una Tarifa"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.tarifarioName }}
                          {{ data.item.text }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          data.item.nombreHorario
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle
                          >{{ data.item.temporadaName }} :
                          {{
                            $pgsHelper
                              .getDate(data.item.Inicio)
                              .format("DD/MM/YYYY")
                          }}
                          -
                          {{
                            $pgsHelper
                              .getDate(data.item.Final)
                              .format("DD/MM/YYYY")
                          }}</v-list-item-subtitle
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>

              <div class="ui buttons" style="width: 100%" v-if="showTypePaid">
                <button
                  v-bind:class="{ green: typePaid == 1, grey: typePaid != 1 }"
                  class="ui button"
                  type="button"
                  @click="selectPaid(1)"
                >
                  <b>
                    <v-icon v-if="typePaid == 1" color="white">
                      mdi-check-circle
                    </v-icon>
                    GOLF INCLUDED
                  </b>
                  <br />
                  <p class="paidDescription">
                    Golf Included in Hotel Reservation
                  </p>
                </button>
                <div class="or"></div>
                <button
                  v-bind:class="{ green: typePaid === 2, grey: typePaid !== 2 }"
                  class="ui button"
                  type="button"
                  @click="selectPaid(2)"
                >
                  <v-icon v-if="typePaid == 2" color="white">
                    mdi-check-circle
                  </v-icon>
                  GUEST PAID
                  <br />
                  <p class="paidDescription">Golf Fee Paid by the Customer</p>
                </button>
              </div>
            </div>
            <!-- end Seccion  tipo de pago si es hotel -->
            <!-- Seccion  codigo Promocional -->
            <div v-if="typePaid === 1">
              <h4 class="ui dividing header">
                4. Reservation Number / Voucher
                <div
                  v-if="errors.code"
                  class="ui left pointing red basic label"
                >
                  Reservation Number / Voucher Code is Required
                </div>
                <!--<template v-if="errors.code">
                                        <span  class="unavailable" style="color:red;">Promotional code is required </span>
                                </template> -->
              </h4>
              <div class="field">
                <input
                  type="text"
                  v-model="promotionalCode"
                  name="promotional"
                  placeholder="Reservation number / Voucher"
                />
              </div>
            </div>
            <!-- end Seccion  codigo Promocional -->
            <!-- Seccion horarios -->
            <h4 class="ui dividing header" v-if="showTypePaid">
              {{ computedStep.stepTime }}. Select Prefered Time
              <b v-if="isHotel">
                {{
                  typePaid === 1
                    ? "- (GOLF INCLUDED)"
                    : typePaid === 2
                    ? " - (GUEST PAID)"
                    : ""
                }}
              </b>
              <div v-if="errors.time" class="ui left pointing red basic label">
                Select a prefered time
              </div>
            </h4>
            <template v-if="typePaid > 0 || !isHotel">
              <!--<div  v-if="isHotel" class="ui row">
                                <div style="float:right;">
                                    <sui-checkbox label="Prefered" toggle @change="showPrefered" v-model="prefered"/>  
                                </div>
                            </div>-->

              <div v-if="tarifas.length >= 1">
                <tabs :key="compIndex">
                  <template v-for="tarifa in compTarifas">
                    <template
                      v-for="(horario, index) in tarifa.HorariosVisibles"
                    >
                      <tab
                        :selected="index == 0"
                        :name="horario.data.Nombre"
                        :key="index"
                      >
                        <div v-if="typePaid === 1">
                          <a
                            style="
                              background: rgba(0, 181, 173, 0.37) !important;
                              color: white;
                              margin-bottom: 2%;
                            "
                            class="ui label"
                          >
                            !</a
                          >
                          Prefered Time for Transportation
                        </div>
                        <div class="ui six doubling cards">
                          <template v-for="(time, index) in times">
                            <timeCard
                              v-if="time.tarifaId == horario.internalId"
                              v-bind:class="{
                                cardActive: index === selectedPriceIndex,
                              }"
                              :showPrice="showPrice"
                              :showPromoPrice="showPromoPrice"
                              :time="time.time"
                              :price="time.precio"
                              :mnd="time.moneda"
                              :priceGlobal="time.precioGlobal"
                              :prefered="time.preferedClass"
                              :players="playersNumber"
                              :reservados="time.personas"
                              :tarifaId="time.tarifaId"
                              :tarifaDocId="tarifa.id"
                              :privado="time.privado"
                              :isAdmin="isAdmin"
                              :selectedDate="input_date"
                              :key="index"
                              @clicked="setSelectedTime"
                            >
                            </timeCard>
                          </template>
                        </div>
                      </tab>
                    </template>
                  </template>
                </tabs>
              </div>
              <!--
                            <div v-if="tarifas.length >= 1" >
                                <vue-tabs :key="compIndex" >
                                    <template   v-for="(tarifa,index) in tarifas">
                                        <v-tab  :title="tarifa.Horario.Nombre" :key="index">
                                            <a style="    background: rgba(0,181,173,.37)!important; color:white; margin-bottom: 2%;" class="ui  label"> !</a> Prefered Time for Transportation
                                            <div class="ui six doubling cards">
                                                <template v-for="(time,index) in times">
                                                        <timeCard 
                                                            v-if="time.tarifaId == tarifa.id"
                                                            v-bind:class="{ cardActive: (index === selectedPriceIndex) }" 
                                                            :time="time.time" 
                                                            :price="time.precio" 
                                                            :priceGlobal="time.precioGlobal"
                                                            :prefered="time.preferedClass"
                                                            :players="playersNumber"
                                                            :reservados="time.personas" 
                                                            :tarifaId="time.tarifaId"
                                                            :privado="time.privado"
                                                            :isAdmin="isAdmin"
                                                            :selectedDate="input_date"
                                                            :key="index"
                                                            @clicked="setSelectedTime"
                                                        >
                                                        </timeCard> 
                                                </template>
                                            </div>
                                        </v-tab> 
                                    </template>
                                </vue-tabs> 
                            </div>
                            -->
            </template>
            <!-- end Seccion horarios -->
          </div>
        </div>
      </div>
      <!-- end Seccion de datos fecha reserva -->

      <!-- Seccion de datos del cliente -->
      <div
        v-show="this.selectedPriceIndex !== ''"
        class="ui column stackable grid segment padded"
      >
        <div id="dataClient" class="ui ten wide column centered">
          <div class="ui clearing">
            <h3 class="ui right floated header">
              <button
                v-if="typePaid == 2 && showAddon"
                type="button"
                class="ui button primary"
                @click="toggleModal"
              >
                Add Cart Riders
              </button>
            </h3>
            <h3 class="ui left floated header">
              {{ computedStep.stepExtraInfo }}. Fill your information
              <div
                v-if="errors.players"
                class="ui left pointing red basic label"
              >
                Fill players information
              </div>
              <!--<template v-if="errors.players">
                                <span  class="unavailable" style="color:red;">Fill players information </span>
                            </template> -->
            </h3>
          </div>
     
          <div v-if="isHotel">
            <h4 class="ui dividing header">Room Number (Optional)</h4>
            <div class="field">
              <input
                type="text"
                v-model="roomNumber"
                name="promotional"
                placeholder="Room Number (Optional)"
              />
            </div>
          </div>
          <h4 class="ui header"></h4>
          <template v-for="(player, index) in players">
            <div class="field" v-bind:key="index">
              <h4 class="ui dividing header">Player {{ index + 1 }}</h4>
              <div class="field">
                <v-text-field
                  type="text"
                  v-model="player.name"
                  name="name"
                  label="Name"
                />
              </div>
              <div class="field">
                <v-text-field
                  type="email"
                  v-model="player.email"
                  name="mail"
                  label="Email"
                />
              </div>
              <div class="field">
                <v-text-field
                  type="number"
                  v-model="player.phone"
                  name="number"
                  label="Phone Number (Optional)"
                />
              </div>
              <div class="field" v-if="showAddon">
                <div class="two fields">
                  <div class="field"> 
                    <v-checkbox
                      :label="
                        'Golf Club + ' +
                          addOn.golfClub.Precio +
                          ' ' +
                          addOn.golfClub.Moneda
                      "
                      toggle
                      v-model="player.golfClub"
                    />
                  </div>
                </div>
                <div class="three fields">
                  <div v-if="player.golfClub" class="field">
                    <label>Gender:</label>
                    <select v-model="player.genero" class="ui fluid dropdown">
                      <option value="Man">Man</option>
                      <option value="Woman">Woman</option>
                    </select>
                  </div>
                  <div v-if="player.golfClub" class="field">
                    <label>Hand:</label>
                    <select v-model="player.side" class="ui fluid dropdown">
                      <option v-if="player.genero == 'Man'" value="left">
                        Left
                      </option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                  <div
                    v-if="player.golfClub && player.genero == 'Man'"
                    class="field"
                  >
                    <label>Shaft:</label>
                    <select v-model="player.shaft" class="ui fluid dropdown">
                      <option value="regular">Regular</option>
                      <option value="stiff">Stiff</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="field" v-if="players.length > 1 && index == 0">
                <div class="ui">
                  <v-checkbox
                    label="Mark others players as guests"
                    toggle
                    @change="changeAsGuest"
                    v-model="checkAsGuest"
                  />
                </div>
              </div>
            </div>
          </template>
          <h4 class="ui dividing header"></h4>
          <div v-show="false" class="field">
            <div class="ui">
              <v-checkbox
                label="Private reservation"
                toggle
                v-model="private_reservation"
              />
            </div>
          </div>
          <h4 class="ui dividing header"></h4>
          <div class="field">
            <transition name="slide-fade">
              <h1 style="float: right">Total:${{ grandTotal.total }}</h1>
            </transition>
          </div>
          <div class="field centered">
            <button v-if="loadingData == false" class="ui button primary">
              Book now
            </button>
          </div>
        </div>
      </div>
      <!-- End Seccion de datos del cliente -->

      <modal  v-model="modalOpen" :title="'Add Cart Riders to reservation'">
        <div>
          <div class="field">
              <div class="ui action input">
                <input
                  type="text"
                  v-model="cartRiderName"
                  placeholder="Cart Rider Name "
                />
                <button type="button" @click="addCartRider" class="ui button">
                  Add +{{ addOn.cartRider.Precio }} {{ addOn.cartRider.Moneda }}
                </button>
              </div>
            </div>
            <div class="ui relaxed divided list">
              <template v-for="(cartRider, index) in cartRiders">
                <div class="item" :key="index">
                  <i class="large user middle aligned icon"></i>
                  <div class="content">
                    <div class="header">{{ cartRider.name }}</div>
                    <div class="description">
                      ${{ addOn.cartRider.Precio }}
                      <a
                        style="float: right"
                        @click="deleteCartRider(index)"
                        href="javascript:void(0);"
                        class="aligned"
                        ><i class="large close middle aligned icon"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </template>
            </div>
        </div>

        <div>
          <v-btn @click="toggleModal">OK</v-btn>
        </div>
      </modal>

      <!-- Modal extra rider -->
      <!-- <sui-modal v-model="modalOpen" size="small">
        <sui-modal-header>Add Cart Riders to reservation</sui-modal-header>
        <sui-modal-content scrolling>
          <sui-modal-description>
            <div class="field">
              <div class="ui action input">
                <input
                  type="text"
                  v-model="cartRiderName"
                  placeholder="Cart Rider Name "
                />
                <button type="button" @click="addCartRider" class="ui button">
                  Add +{{ addOn.cartRider.Precio }} {{ addOn.cartRider.Moneda }}
                </button>
              </div>
            </div>
            <div class="ui relaxed divided list">
              <template v-for="(cartRider, index) in cartRiders">
                <div class="item" :key="index">
                  <i class="large user middle aligned icon"></i>
                  <div class="content">
                    <div class="header">{{ cartRider.name }}</div>
                    <div class="description">
                      ${{ addOn.cartRider.Precio }}
                      <a
                        style="float: right"
                        @click="deleteCartRider(index)"
                        href="javascript:void(0);"
                        class="aligned"
                        ><i class="large close middle aligned icon"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </sui-modal-description>
        </sui-modal-content>
        <sui-modal-actions>
          <button type="button" @click="toggleModal" class="ui button positive">
            OK
          </button>
        </sui-modal-actions>
      </sui-modal> -->
      <!-- end Modal extra rider -->
    </form>
  </div>
</template>

<style>
@media only screen and (max-width: 600px) {
  .paidDescription {
    display: none !important;
  }
}

.vdp-datepicker__calendar {
  width: 100% !important;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
  .paidDescription {
    display: none !important;
  }
}
</style>

<script>
//const $ = require('jquery');
//window.$ = $;

import moment from "moment";
import Datepicker from "vuejs-datepicker";
import timeCard from "../../MainComponents/timeCard.vue";
import selectTipoJuego from "../../MainComponents/selectTipoJuego.vue";

import modal from "../../MainComponents/modal.vue";

import "../../../assets/css/custom.css";
import TarifasClass from "../../../clases/Tarifa.js"
import ReservaClass from "../../../clases/Reserva.js"

export default {
  name: "reserva",
  components: {
    Datepicker,
    timeCard,
    selectTipoJuego,
    modal
  },
  data() {
    return {
      ConfigRva:null,
      MainDepartamento: "Golf",
      tarifario: "",
      tarifa: "",
      tarifaCombo: [],
      listadoTarifas: [],
      typeTransportation: 1,
      index_hotel: "",
      hoteles: [],
      input_date: moment(),
      actualDate: moment(),
      roomNumber: "",
      isAdmin: false,
      transportation: false,
      loadingData: false,
      private_reservation: false,
      isPreferedTime: false,
      Session: "",
      ApiToken: "",
      TotalTrans: 0,
      RowId: "",
      DuracionViaje: "",
      rawDuracionViaje: "",
      HtlPickup: "",
      PCGCPickup: "",
      selectedHtlPickup: "",
      selectedPCGCPickup: "",
      checkAsGuest: false,
      promotionalCode: "",
      selectedTarifa: "",
      compIndex: 0,
      actualListener: "",
      prefered: true,
      RsvaTransId: "",
      // Confirm:"",
      modalOpen: false,
      selectedPriceIndex: "",
      selectedTime: "",
      playersNumber: 1,
      cartRiderName: "",
      addOn: { cartRider: "", golfClub: "", transport: "" },
      hoyos: "",
      players: [
        {
          name: "",
          email: "",
          phone: "",
          golfClub: false,
          side: "right",
          genero: "Man",
          shaft: "regular",
        },
      ],
      tiposJuego: [],
      temporadas: [],
      tarifas: [],
      tarifaGlobal: [],
      times: [],
      reservas: [],
      cartRiders: [],
      daysRules: [],
      Horarios: [],
      subcategorias: [],
      comboPlayers: [
        { value: "1", text: "1 Player" },
        { value: "2", text: "2 Player" },
        { value: "3", text: "3 Player" },
        { value: "4", text: "4 Player" },
      ],
      initTime: new moment("06:00", "HH:mm"),
      endTime: new moment("18:00", "HH:mm"),
      configTime: {},
      intervalo: 10,
      errors: {
        time: false,
        players: false,
        code: false,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(moment()),
          //new Date(2020, 0, 17),
          //new Date(2020, 0, 18)
        ],
      },
    };
  },
  props: ["isHotel", "isWeb"],
  methods: {
    init() {

      this.getTiposJuego()
        .then(() => {
          return this.getTemporadas();
        })
        .then(async () => {
          await this.getHoteles();
          await this.getSubcategoria();
          await this.getHorarios();
          await this.getTarifasCombo();
          await this.getAddons();
          await this.getDaysRules();

        });
    },
     async getTarifasByTarifario() {
      let idTemporada = "";
      let temporadasAplicables = [];
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          temporadasAplicables.push(element.id);
          idTemporada = element.id;
        }
      });
      let TarifasCombo = [];
      let TarifasList = []; // new method
      let taskTarifas = temporadasAplicables.map(async (id) => {
        let tarifas = await TarifasClass.getMixTarifasByTarifarioParse(
          this.tarifario,
          id,
          this.MainDepartamento,
          this.Horarios,
          this.temporadas,
          this.tiposJuego,
          this.input_date.day()
        );
        tarifas.forEach((tar) => {
          TarifasList.push(tar);
        });
      });
      await Promise.all(taskTarifas).then(() => {
        TarifasList.forEach((tarifa, index) => {
          let nameTarifa = "Tarifa: ";
          let categoriaId = null;
          let categoriaName = null;
          tarifa.Subcategoria.forEach((element) => {
            categoriaId = element;
            nameTarifa +=
              this.$pgsHelper.getById(this.subcategorias, "id", element)
                .Nombre + " ";
            categoriaName = this.$pgsHelper.getById(
              this.subcategorias,
              "id",
              element
            ).Nombre;
          });
          let nombreHorario = ""
          let Precio = 0
          let PrecioCon = 0
          if (tarifa.arrayPrecios) {
            
            tarifa.arrayPrecios.forEach((modalidad) => {
              if (modalidad.id == this.modalidad) {

                modalidad.horarios.forEach((horario) => {
                  if (
                    moment(horario.data.HoraTermino, "HH:mm:ss").format("HH:mm") >=
                      moment(this.selectedTime, "HH:mm").format("HH:mm") &&
                    moment(horario.data.HoraInicio, "HH:mm:ss").format("HH:mm") <=
                      moment(this.selectedTime, "HH:mm").format("HH:mm")
                  ) {
                    nombreHorario = horario.data.Nombre
                    Precio = horario.PcoVen + " "+ horario.Moneda,
                    PrecioCon = horario.PcoCon + " " + horario.Moneda,
                    /*this.players[index].TarifaSelected = {
                      Tarifa: tarifa,
                      Nombre: tarifa.text,
                      TarifaId: tarifa.value,
                      Horario: horario,
                      horarioNombre: horario.data.Nombre,
                      tarifarioNombre: tarifarioData.Nombre,
                      Precio: horario.PcoVen,
                      PrecioCon: horario.PcoCon,
                      Moneda: horario.Moneda,
                    };*/

                    this.$forceUpdate();
                  }
                });
              }
            });
          }
          TarifasCombo.push({
            value: tarifa.id,
            text: nameTarifa,
            data: tarifa,
            nombreHorario:nombreHorario,
            Turista:tarifa.Turista || false,
           Color:tarifa.Color || null,
            Precio:Precio,
            PrecioCon:PrecioCon,
            tarifarioName: this.$pgsHelper.getById(
              this.tarifaCombo,
              "value",
              tarifa.Tarifario
            ).text,
            Inicio: this.$pgsHelper.getById(
              this.temporadas,
              "id",
              tarifa.Temporada
            ).FechaInicio,
            Final: this.$pgsHelper.getById(
              this.temporadas,
              "id",
              tarifa.Temporada
            ).FechaTermino,
            temporadaName: this.$pgsHelper.getById(
              this.temporadas,
              "id",
              tarifa.Temporada
            ).Nombre,
            cateTarifa: {
              id: categoriaId,
              nombre: categoriaName,
            },
          });
        });

        this.listadoTarifas = TarifasCombo;
      });
    },


    async getSubcategoria() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("RVA/Tarifas/Golf/SubCategorias")
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.$pgsHelper.log(element);
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("RVA/Tarifas/Golf/Horarios");

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    async getTarifasCombo() {
      let mayoristas = this.hoteles;
      let mayoristaData = this.$pgsHelper.getById(
        mayoristas,
        "Codigo",
        this.$route.params.user.tokenResult.claims.Code
      );
      let tarifarios = await TarifasClass.getMixTarifasComboByAcceso(
        "Golf",
        mayoristaData.id
      );
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      
      this.tarifaCombo = tarifarios;
      this.$forceUpdate()
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      this.hoteles = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database
        .queryBuilder("RVA/Mayoristas/Coleccion")
      this.hoteles = [];
      let arrayHoteles = Object.entries(snapshot.val());
      arrayHoteles.forEach((element) => {
        this.hoteles.push({ id: element[0], ...element[1] });
      });
    },
    getHotelinfoByCode(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { Codigo: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    changeTypeTransportation() {
      if (this.typeTransportation == 1) {
        this.TotalTrans =
          this.typePaid === 1
            ? this.playersNumber >= 4
              ? 0
              : this.getHotelinfoByCode(
                  this.$route.params.user.tokenResult.claims.Code
                ).PrecioRT
            : this.playersNumber >= 2
            ? 0
            : this.getHotelinfoByCode(
                this.$route.params.user.tokenResult.claims.Code
              ).PrecioRT;
        (this.selectedHtlPickup = this.HtlPickup),
          (this.selectedPCGCPickup = this.PCGCPickup);
      } else if (this.typeTransportation == 2) {
        this.TotalTrans =
          this.typePaid === 1
            ? this.playersNumber >= 4
              ? 0
              : this.getHotelinfoByCode(
                  this.$route.params.user.tokenResult.claims.Code
                ).PrecioOWHG
            : this.playersNumber >= 2
            ? 0
            : this.getHotelinfoByCode(
                this.$route.params.user.tokenResult.claims.Code
              ).PrecioOWHG;
        (this.selectedHtlPickup = this.HtlPickup),
          (this.selectedPCGCPickup = "NA");
      } else if (this.typeTransportation == 3) {
        this.TotalTrans =
          this.typePaid === 1
            ? this.playersNumber >= 4
              ? 0
              : this.getHotelinfoByCode(
                  this.$route.params.user.tokenResult.claims.Code
                ).PrecioOWGH
            : this.playersNumber >= 2
            ? 0
            : this.getHotelinfoByCode(
                this.$route.params.user.tokenResult.claims.Code
              ).PrecioOWGH;
        (this.selectedHtlPickup = "NA"),
          (this.selectedPCGCPickup = this.PCGCPickup);
      }
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    addCartRider() {
      if (this.cartRiderName !== "") {
        this.cartRiders.push({ name: this.cartRiderName });
        this.cartRiderName = "";
        if (this.transportation) {
          this.getTransportationData();
        }
      } else {
        this.$swal({
          allowOutsideClick: false,
          icon: "error",
          title: "Cart Rider Name is required",
          text: "",
        });
      }
    },
    deleteCartRider(index) {
      this.cartRiders.splice(index, 1);
      this.getTransportationData();
    },
    changePlayersNumber() {
      this.resetSelect();
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.players.length < this.playersNumber) {
        var i;
        for (i = this.players.length; i < this.playersNumber; i++) {
          this.players.push({
            name: "",
            email: "",
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
          });
        }
      } else if (this.players.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.players.length; i) {
          this.players.pop();
        }
      }
      if (this.transportation) {
        this.getTransportationData();
      }
    },
    changeTrans(value) {
      this.transportation = value;
      if (this.selectedPriceIndex === "") {
        this.$swal(
          "Selecciona un horario",
          "Selecciona un horario de juego antes de solicitar transportacion ",
          "error"
        );

        document.getElementsByName("trans").forEach((element) => {
          element.checked = false;
        });
      } else if (this.transportation && this.selectedPriceIndex !== "") {
        if (this.isHotel) {
          this.getTransportationData();
        }
      } else {
        this.Session = "";
        this.ApiToken = "";
        this.TotalTrans = 0;
        this.RowId = "";
        this.RsvaId = "";
        this.DuracionViaje = "";
        this.HtlPickup = "";
        this.PCGCPickup = "";
        //this.Confirm ="";
        this.$swal(
          "No se transportara a los jugadores",
          "La transportacion al campo de golf  no sera incluida en esta reserva ",
          "error"
        );
      }
    },
    changeHoyos() {
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = ""), this.compIndex++;
      this.getTarifas();
    },
    changeAsGuest() {
      var $this = this;
      if (this.checkAsGuest == true) {
        var pNumber = 1;
        $this.players.forEach(function (element, index) {
          if (index != 0 && element.name == "") {
            element.name = "Guest " + pNumber;
            element.email = "guest@guestmail.com";
            pNumber++;
          }
        });
      } else {
        $this.players.forEach(function (element, index) {
          if (index != 0) {
            element.name = "";
            element.email = "";
          }
        });
      }
    },
    showPrefered() {
      this.resetSelect();
      if (this.prefered) {
        /* this.times.forEach((element)=>{
                   element.prefered = false;
           });*/
        this.times.forEach((element, index) => {
          if (element.personas > 0 && element.prefered == true) {
            this.times[index - 1].preferedClass = true;
            element.preferedClass = true;
            this.times[index + 1].preferedClass = true;
          }
        });
      } else if (this.prefered === false) {
        this.times.forEach((element) => {
          element.preferedClass = true;
        });
      }
    },
    setSelectedTime(key, time, idTarifa, prefered) {
      //alert(key + ' ' + time + ' ' + total);

      this.selectedPriceIndex = key;
      this.selectedTime = time;
      this.selectedTarifa = idTarifa;
      this.isPreferedTime = prefered;

      this.$nextTick(() => {
        document.getElementById("dataClient").scrollIntoView();
      });
    },
    selectDate(arg) {
      //let oldDate= this.input_date.format('YYYY-MM-DD');
      //this.killListener(oldDate);
      this.input_date = moment(arg);
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = ""), this.getTarifas();
    },
    setInitialDate() {
      this.input_date.format("YYYY-MM-DD");
      let aux = false;
      this.daysRules.forEach((element) => {
        if (element.data.Abre && element.data.Cierra) {
          if (this.input_date.format("YYYY-MM-DD") === element.date) {
            this.initTime = new moment(element.data.Abre, "HH:mm:ss");
            this.endTime = new moment(element.data.Cierra, "HH:mm:ss");
            aux = true;
          }
        }
      });
      if (!aux) {
        this.initTime = this.configTime.initTime;
        this.endTime = this.configTime.endTime;
      }
    },
    killListener(date) {
      const ref = this.$store.getters.getFirebaseApp.database.ref("RVA/Reservas/" + this.MainDepartamento + "/" + date)
      this.$store.getters.getFirebaseApp.database.off(ref);
    },
    selectPaid(value) {
      this.$store.commit("setTypePaid", value);
      this.getTarifas();
    },
    resetSelect() {
      this.selectedPriceIndex = "";
      this.isPreferedTime = false;
      document.getElementsByName("trans").forEach((element) => {
        element.checked = false;
      });
      this.$store.commit("setPriceSelected", 0);
      this.$store.commit("setMndSelected", "");
    },
    async getTarifas() {
      let idTemporada = "";
      let temporadasAplicables = [];
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          temporadasAplicables.push(element.id);
          idTemporada = element.id;
        }
      });

      let TarifasCombo = [];
      let TarifasList = []; // new method
      let taskTarifas = temporadasAplicables.map(async (id) => {
        let tarifas = await TarifasClass.getMixTarifasByTarifarioParse(
          this.tarifario,
          id,
          this.MainDepartamento,
          this.Horarios,
          this.temporadas,
          this.tiposJuego,
          this.input_date.day()
        );
        tarifas.forEach((tar) => {
          TarifasList.push(tar);
        });
      });

       await Promise.all(taskTarifas).then(async () => {
        this.tarifas = [this.$pgsHelper.getById(TarifasList, "id", this.tarifa)];
      
      await this.getReservas();
      this.buildTimesData();
      this.loadingTarifas = false;
      this.$forceUpdate();
      this.forceRecomputeCounter++;
       })


    },
    getServicesIncludes() {},
    async testRealTime() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("Configuracion/Reservas/EmailCCO")
        .once("value");
      this.$pgsHelper.log(data.val());
    },
    async getTransportationData() {
      /*
        Obiene la informacion de la transportacion para la reserva
        */
      let hotelData = this.getHotelinfoByCode(
        this.$route.params.user.tokenResult.claims.Code
      );
      let EPId = hotelData.Transportacion.ExtraParams.EpHotelId;
      let duracion = hotelData.Transportacion.DuracionViaje;

      if (!hotelData.ActiTrans) {
        this.transportation = false;
        this.$swal(
          "La Transportación esta descativada para este usuario",
          "Contacte al campo de golf para activar la transportacion",
          "error"
        );

        return false;
      }

      let data = {
        PaxNumber: this.players.length + this.cartRiders.length,
        EpHotelId: EPId,
        DuracionViaje: duracion,
        Prefered: this.isPreferedTime,
        Fecha:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
      };
      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-transportationAvailability');
      return await this.$store.getters.getFirebaseApp.fba
        .call("Golf-Reservas-transportationAvailability", data, {})
        .then((result) => {
          this.Session = result.data.data.Session;
          this.ApiToken = result.data.data.ApiToken;
          this.TotalTrans =
            this.typePaid === 1
              ? this.playersNumber >= 4
                ? 0
                : hotelData.Transportacion.PrecioRT
              : this.playersNumber >= 2
              ? 0
              : hotelData.Transportacion.PrecioRT;
          this.RowId = result.data.data.RowId;
          this.RsvaTransId = result.data.data.RsvaTransId;
          this.rawDuracionViaje = result.data.data.DuracionViaje;
          this.DuracionViaje = moment(
            result.data.data.DuracionViaje,
            "HH:mm:ss"
          ).format("HH [Hrs] : mm [Min].");
          this.HtlPickup = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          this.PCGCPickup = moment(
            result.data.data.PCGCPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          (this.selectedHtlPickup = this.HtlPickup),
            (this.selectedPCGCPickup = this.PCGCPickup);
          //this.Confirm= result.data.data.Confirm;
          this.loadingData = false;
        })
        .catch((error) => {
          this.$pgsHelper.log(error);
        });
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("RVA/Tarifas/" + this.MainDepartamento + "/Modalidades");
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach(function (element) {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        $this.hoyos = element[0];
      });
    },
    async getTemporadas() {
      /*
         Obtiene las temporadas existentes en la db
        */
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder("RVA/Tarifas/" + this.MainDepartamento + "/Temporadas");

      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        if(element[1].Activo){
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
    async getAddons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let addons = this.$store.getters.getRVACatalogo;
      this.$pgsHelper.log(addons);

      this.addOn.cartRider = addons.GOLFRIDDER; //arrayExt;

      this.addOn.golfClub = addons.GOLFCLUB; //arrayGb;


      this.addOn.transport = addons.TRANSPORT;
    },
    async getReservas() {
      /*
            Se obtiene las disponibilidad por dia y la cantidad de personas reservadas en esos dias
        */
      let date = this.input_date.format("YYYY-MM-DD");
      this.killListener(this.actualListener);
      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Reservas/" + this.MainDepartamento + "/" + date,
        null,
        (snapshot) => {
          if (snapshot.exists()) {
            this.reservas = [];
            let arrayReservas = snapshot.val();
            this.reservas = ReservaClass.parseAvailabilityData(arrayReservas);
            this.totalPlayers = 0;
            this.reservas.forEach((element) => {
              this.totalPlayers = this.totalPlayers + element.PAX;
              this.totalReservas =
                this.totalReservas + Object.keys(element.Rvs).length;
            });
          } else {
            this.reservas = [];
            this.totalPlayers = 0;
          }
          this.buildTimesData();
          this.showPrefered();
        }
      )

      this.actualListener = date;
    },
    async getDaysRules() {
      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Configuracion/" + this.MainDepartamento + "/Calendario",
        null,
        (snapshot)=>{
          if (snapshot.exists()) {
            this.daysRules = [];
            if (snapshot.val().Fechas_Especiales) {
              let arrayCalendar = Object.entries(
                snapshot.val().Fechas_Especiales
              );
              arrayCalendar.forEach((element) => {
                this.daysRules.push({ date: element[0], data: element[1] });
              });

              //ordena las reglas por fecha
              this.daysRules.sort(function compare(a, b) {
                return a.date - b.date;
              });
              //si la fecha inicial esta entre las reglas como un dia cerrado aumenta un dia
              this.daysRules.forEach((element) => {
                if (
                  element.date == this.input_date.format("YYYY-MM-DD") &&
                  element.data == false
                ) {
                  this.input_date.add(1, "days");
                  this.date = this.input_date.format("YYYY-MM-DD");
                }
              });
              // si es un lunes, verificar si en las reglas abre , si no aumentar un dia
             /* if (this.input_date.weekday() === 1) {
                let abre = false;
                this.daysRules.forEach((element) => {
                  if (
                    element.date == this.input_date.format("YYYY-MM-DD") &&
                    element.data == true
                  ) {
                    abre = true;
                  }
                });

                if (abre == false) {
                  this.input_date.add(1, "days");
                  this.date = this.input_date.format("YYYY-MM-DD");
                }
              }*/

              this.configTime.initTime = new moment(
                snapshot.val().Hora_Apertura,
                "HH:mm:ss"
              );
              this.configTime.endTime = new moment(
                snapshot.val().Hora_Cierre,
                "HH:mm:ss"
              );
            } else {
              /*if (this.input_date.weekday() === 1) {
                this.input_date.add(1, "days");
                this.date = this.input_date.format("YYYY-MM-DD");
              }*/
              this.configTime.initTime = new moment(
                  snapshot.val().Hora_Apertura,
                  "HH:mm:ss"
                );
                this.configTime.endTime = new moment(
                  snapshot.val().Hora_Cierre,
                  "HH:mm:ss"
                );
                this.daysRules = [];
            }
          } else {
            this.daysRules = [];
          }
        }
      );
    },
    buildTimesData() {
      /*
            Genera el array conteniendo cada horario disponible para reserva en un intervalo de 10 minutos desde la hora inicial y la hora final
        */
      this.initTime = "";
      this.endTime = "";
      this.setInitialDate();
      let initTim = new moment(this.initTime.format("HH:mm"), "HH:mm");
      let endTime = new moment(this.endTime.format("HH:mm"), "HH:mm");

      let auxDate = initTim;
      this.times = [];

      var i;
      /*para cada uno de los horarios armados se asignan los datos necesarios*/
      for (i = 0; auxDate.format("HH:mm") <= endTime.format("HH:mm"); i++) {
        var idTarifa;
        let precio;
        var idTarifaGlobal = "";
        var precioGlobal = "";
        var moneda;
        let personas = 0;
        let privado = false;
        let prefered = false;
        /* Se asigna la tarifa y el precio */
        this.tarifas.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              if (modalidad.id == this.hoyos) {
                if (
                  horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                  horario.data.HoraTermino >= auxDate.format("HH:mm:ss")
                ) {
                  idTarifa = horario.internalId;
                  precio = horario.PcoVen;
                  moneda = horario.Moneda;
                }
              }
            });
          });
        });
        /*Se asigna la tarifa global y el precio global*/
        this.tarifaGlobal.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              if (modalidad.id == this.hoyos) {
                if (
                  horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                  horario.data.HoraTermino >= auxDate.format("HH:mm:ss")
                ) {
                  idTarifaGlobal = horario.internalId;
                  precioGlobal = horario.PcoVen;
                }
              }
            });
          });
        });

        /*en caso de que tengan reservas en ese Horario y dia seleccionado se agregan a los datos*/
        this.reservas.forEach((element) => {
          let time = new moment(element.time, "HH:mm:ss");
          if (time.format("HH:mm") == auxDate.format("HH:mm")) {
             let rvs = element.Rvs ? element.Rvs : {};
            let rvsArray = Object.entries(rvs);
            rvsArray.forEach((res) => {
              if (res[1].Pys) {
                res[1].Pys.forEach((ply) => {
                  if (
                    ply.E == "R" ||
                    ply.E == "P" 
                  ) {
                    personas++
                  }
                });
              }
            });
            if (this.isHotel) {
              prefered = element.Prefered ? true : false;
            } else {
              prefered = false;
            }
            privado = element.Privado ? element.Privado : false;
          }
        });

        if(!precio){
          privado  = true
        }

        /* se agregan al array*/
        this.times.push({
          time: auxDate.format("HH:mm"),
          tarifaId: idTarifa,
          tarifaIdGlobal: idTarifaGlobal,
          precioGlobal: precioGlobal,
          precio: precio,
          personas: personas,
          moneda: moneda,
          privado: privado,
          prefered: prefered,
        });
        auxDate = auxDate.add(10, "minutes");
      }
    },
    validation() {
      var valid = true;

      if (this.selectedPriceIndex === "") {
        valid == false;
        this.errors.time = true;
      } else {
        this.errors.time = false;
      }
      let aux = 0;
      this.players.forEach((element) => {
        if (element.name == "" || element.email == "") {
          aux++;
        }
      });

      if (aux > 0) {
        valid = false;
        this.errors.players = true;
      } else {
        this.errors.players = false;
      }

      if (this.typePaid === 1 && this.promotionalCode === "") {
        valid = false;
        this.errors.code = true;
      } else {
        this.errors.code = false;
      }

      return valid;
    },
    buildReservationData() {
      this.players.forEach((element, index) => {
        let tarifa = this.$pgsHelper.getById(
          this.tarifas,
          "id",
          this.selectedTarifa
        );
        let tarifaName = "";
        tarifa.Subcategoria.forEach((element) => {
          tarifaName +=
            this.$pgsHelper.getById(this.subcategorias, "id", element).Nombre +
            " ";
        });
        tarifa.arrayPrecios.forEach((modalidad) => {
          modalidad.horarios.forEach((horario) => {
            if (modalidad.id == this.hoyos) {
              if (
                horario.data.HoraInicio <=
                  moment(this.selectedTime, "HH:mm").format("HH:mm:ss") &&
                horario.data.HoraTermino >=
                  moment(this.selectedTime, "HH:mm").format("HH:mm:ss")
              ) {
                this.players[index].TarifaSelected = {
                  Tarifa: tarifa,
                  Nombre: tarifaName,
                  TarifaId: tarifa.id,
                  Turista:tarifa.Turista,
                  Color:tarifa.Color,
                  Horario: horario,
                  horarioNombre: horario.data.Nombre,
                  Precio: horario.PcoVen,
                  PrecioCon: horario.PcoCon,
                  Moneda: horario.Moneda,
                };
                this.$forceUpdate();
              }
            }
          });
        });
      });

      let resData = ReservaClass.buildRVAData({
        Tipo: "Golf",
        Cliente: this.players[0],
        Players: this.players,
        Estatus: "Confirmed",
        Familia:this.ConfigRva?.Contabilidad?.Familia,
        Privado: false,
        FechaInicial:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
        Total: this.grandTotal,
        Prepagado: this.typePaid === 1 ? true : false,
        Notas: this.nota,
        Departamento: this.MainDepartamento,
        Tags: ["GOLF"],
        Creador: "Mayorista",
        Modalidad: this.$pgsHelper.getById(this.tiposJuego, "id", this.hoyos),
        CartRiders: this.cartRiders,
        Addons: this.Addons,
        Mayorista: {
          Id: this.mayoristaData.id,
          Nm: this.mayoristaData.Nombre,
        },
        Transportacion: null,
      });

      return resData;
    },
    async getConfig() {
      const conf =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Configuracion/" + localStorage.getItem("selectedDepartment") + ""
        );
      let resultConf = conf.val();
      this.ConfigRva = resultConf;
    },
    bookNow() {
      let validation = this.validation();
      if (validation) {
        let reservationData = this.buildReservationData();

        this.$swal({
          title: "¿Deseas generar esta reserva?",
          text:
            "Los datos de la reserva no podran ser modificados posteriormente",
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Book now!",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            //var addReserva = this.$store.getters.getFirebaseApp.fba.call('RVA-Reservas-crearReserva');
            return await this.$store.getters.getFirebaseApp.fba
              .call("RVA-Reservas-crearReserva", reservationData)
              .then(function (result) {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              let transReservation = "";

              if (result.value.data.data.Transportacion) {
                transReservation =
                  "Transportation number:" +
                  result.value.data.data.Transportacion.Confirmacion;
              }

              this.$swal({
                allowOutsideClick: false,
                title: "Reserved",
                text:
                  "Your reservation is done, we send an email with reservation info.    Reservation No. " +
                  result.value.data.data.Folio +
                  " " +
                  transReservation,
                icon: "success",
              }).then(() => {
                if (this.isWeb) {
                  location.href = "https://www.puertocancun.com";
                } else {
                  this.$emit("changeIndex");
                }
              });

              this.$emit("changeIndex");
            } else {
              this.$swal(
                "Error saving reservation",
                result.value.data.error,
                "error"
              );
            }
          }
        });
      }
    },
  },
  computed: {
    showTypePaid(){
      if(this.$store.getters.getFirebaseApp.tenant == "PCUN"){
        return true
      }
      return false

    },
    showAddon(){
      if(this.$store.getters.getFirebaseApp.tenant == "PCUN"){
        return true
      }
      return false

    },
    showPromoPrice(){
      if(this.$store.getters.getFirebaseApp.tenant == "PCUN"){
        return true
      }
      return false

    },
    showPrice(){

      return true
    },
    Addons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let AddOn = {};
      let addons = this.$store.getters.getRVACatalogo;

      AddOn.cartRider = addons.GOLFRIDDER;
      AddOn.golfClub = addons.GOLFCLUB;
      AddOn.transport = addons.TRANSPORT;
      AddOn.roundGolf = addons.GOLFROUND;
      return AddOn;
    },
    compTarifas() {
      let compTarifas = [];

      this.tarifas.forEach((tarifa) => {
        let HorarioAplicable = [];
        tarifa.arrayPrecios.forEach((modalidad) => {
          modalidad.horarios.forEach((horario) => {
            if (modalidad.id == this.hoyos) {
              if (this.showAll) {
                this.$pgsHelper.log("mostrar todos");
                HorarioAplicable.push(horario);
              } else {
                if (
                  moment(
                    this.input_date.format("YYYY-MM-DD") +
                      horario.data.HoraTermino,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("YYYY-MM-DD HH:mm:ss") >
                  this.actualDate.format("YYYY-MM-DD HH:mm:ss")
                ) {
                  HorarioAplicable.push(horario);
                }
              }
            }
          });
        });
        tarifa.HorariosVisibles = HorarioAplicable;
        compTarifas.push(tarifa);
      });
      return compTarifas;
    },
    tiposCambio() {
      let cambio = this.$store.getters.getTiposCambios;
      return cambio[0];
    },
    mayoristaData() {
      let mayoristas = this.$store.getters.getMayoristas;
      let mayoristaData = this.$pgsHelper.getById(
        mayoristas,
        "Codigo",
        this.$route.params.user.tokenResult.claims.Code
      );
      return mayoristaData;
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },
    grandTotal() {
      /* calcula el total de la reserva, segun el tipo de pago y los items seleccionados */
      let total = 0;
      let totalPesos = 0;
      let Moneda = this.$store.getters.getMndSelected;
      let montoTarifa =
        this.$store.getters.getPriceSelected != ""
          ? this.$store.getters.getPriceSelected
          : 0;
      total += parseInt(this.TotalTrans);
      if (Moneda == "USD") {
        total += montoTarifa;
        totalPesos += montoTarifa * this.tiposCambio.TC.USD;
      } else if (Moneda == this.$Currencies.getCurrencyDefault()) {
        total += montoTarifa / this.tiposCambio.TC.USD;
        totalPesos += montoTarifa;
      }
      if (this.typePaid === 1) {
        total = 0;
        totalPesos = 0;
      }
      total += parseInt(this.TotalTrans);
      totalPesos += parseFloat(this.TotalTrans) * (this.tiposCambio?.TC?.USD || 0);
      this.players.forEach((element) => {
        if (element.golfClub) {
          if (this.addOn.golfClub.Moneda == "USD") {
            total += this.addOn.golfClub.Precio;
            totalPesos += this.addOn.golfClub.Precio  * (this.tiposCambio?.TC?.USD || 0);
          } else {
            total += this.addOn.golfClub.Precio / (this.tiposCambio?.TC?.USD || 0);
            totalPesos += this.addOn.golfClub.Precio;
          }
        }
      });
      this.cartRiders.forEach(() => {
        if (this.addOn.cartRider.Moneda == "USD") {
          total += this.addOn.cartRider.Precio;
          totalPesos += this.addOn.cartRider.Precio * (this.tiposCambio?.TC?.USD || 0);
        } else {
          total += this.addOn.cartRider.Precio / (this.tiposCambio?.TC?.USD || 0);
          totalPesos += this.addOn.cartRider.Precio;
        }
      });

      return { total: total, totalPesos: totalPesos };
    },
    computedStep() {
      let step = 3;
      let stepExtraInfo = 4;
      if (this.isHotel) {
        if (this.typePaid == 2) {
          step = 4;
          stepExtraInfo = 5;
        } else if (this.typePaid == 1) {
          step = 5;
          stepExtraInfo = 6;
        } else if (this.typePaid == "") {
          step = 4;
          stepExtraInfo = 5;
        }
      }

      return { stepTime: step, stepExtraInfo: stepExtraInfo };
    },
    disabledDates() {
      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        } else {
          open_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        }
      });

      return {
        to: new Date(moment().subtract(1, "days")),
        dates: disable_dates,
        customPredictor: function (date) {
          let aux = true;
          let dateFormat =
            date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
         /*if (date.getDay() == 1) {
            open_dates.forEach((element) => {
              let openDate =
                element.getFullYear() +
                "-" +
                element.getMonth() +
                "-" +
                element.getDate();
              if (openDate == dateFormat) {
                aux = false;
              }
            });

            return aux;
          }*/
        },
      };
    },
  },
  mounted() {
    this.showPrefered();
    //this.testRealTime();
  },
  beforeMount() {
    this.MainDepartamento = localStorage.getItem("GolfDepartment");
    this.getConfig();
    if (this.isHotel) {
      this.prefered = true;
    }
    if (this.isWeb) {
      this.$store.commit("setTypePaid", 2);
    }

    if (!this.isWeb && !this.isHotel) {
      this.$store.commit("setTypePaid", 2);
      this.isAdmin = true;
    }

    this.$store.commit("setGlobalPrice", 190);
    this.init();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
};
</script>
